// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const inlineIconButtonClasses = {
  icon: "qui-inline-icon-button__icon",
  root: "qui-inline-icon-button__root",
} as const
